import { ReturnToAdmin } from './ReturnToAdmin';

export default ReturnToAdmin;
